import LabServiceModel from "@/models/LabServiceModel";
import AnalyteCollection from "@/collections/lab/AnalyteCollection";
import ServiceInstructionCollection from "@/collections/lab/ServiceInstructionCollection";
import ServiceQuestionCollection from "@/collections/lab/ServiceQuestionCollection";
import TurnaroundCollection from "@/collections/lab/TurnaroundCollection";
import PrepWorkflowCollection from "@/collections/lab/PrepWorkflowCollection";

export default class SampleTypeModel extends LabServiceModel {
  modelName() {
    return 'sample-type';
  }
  icon() {
    return 'shovel';
  }
  defaults() {
    return {
      id: null,
      name: null,
      description: null,
      position: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      analytes: {},
      service_instructions: {},
      service_questions: {},
      turnarounds: {},
      prep_workflows:{},
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      position: Number,
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }
  validation() {
    return {}
  }
  getAnalytes() {
    return this.getRelatedCollection(new AnalyteCollection(), 'analytes');
  }
  getServiceInstructions() {
    return this.getRelatedCollection(new ServiceInstructionCollection(), 'service_instructions');
  }
  getServiceQuestions() {
    return this.getRelatedCollection(new ServiceQuestionCollection(), 'service_questions');
  }
  getTurnarounds() {
    return this.getRelatedCollection(new TurnaroundCollection(), 'turnarounds');
  }
  getPrepWorkflows() {
    return this.getRelatedCollection(new PrepWorkflowCollection(), 'prep_workflows');
  }
  static initGeneralModel() {
    return new this({
      id: null,
      name: 'General'
    });
  }

}
